import React, { Suspense } from 'react';
import he from "he";

import Belt from '../components/Belt';
import BeltLogged from '../components/BeltLogged';

import Footer from '../components/Footer';
import FechGetSparingpartnerBySlug from "../fechData/FechGetSparingpartnerBySlug";

import AuthService from "../services/auth.service";

class SparingpartnerPage extends React.Component {
  state = {
    currentUser: AuthService.getCurrentUser(),
    dataAdverbSparinParner: {
      successful: false,
      status: "",
      message: "",
      data: {}
    },
    loading: true // <-- nowy stan
  };

  async componentDidMount() {
    const title =
      "Sparingpartnerzy " + this.props.match.params.slug + " - RezerwujKort.pl";
    document.title = title;

    try {
      this.setState({ loading: true });
      const response = await FechGetSparingpartnerBySlug(
        this.props.match.params.slug
      );
      this.setState({
        dataAdverbSparinParner: response,
        loading: false
      });
    } catch (error) {
      console.error("Błąd pobierania sparingpartnera:", error);
      this.setState({ loading: false });
    }
  }

  render() {
    const { loading, dataAdverbSparinParner } = this.state;

    if (loading) {
      return (
        <div className="loading-container" style={{ textAlign: "center", padding: "50px" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Ładowanie...</span>
          </div>
        </div>
      );
    }

    const data = dataAdverbSparinParner.data || {};
    const descStyle = {
          whiteSpace: "pre-wrap",       // zachowuje \n jako nowe linie
          wordWrap: "break-word",       // łamanie długich słów
          overflowWrap: "break-word"    // nowoczesne łamanie słów
        };
    return (
      <div>
        <Belt />
        <BeltLogged />

        <div id="content">
          <div className="container">
            <div className="main-subpage subpage-user">
              <div className="head">
                <img src={`/images/login.png`} alt="login icon" />
                <p>Sparingpartnerzy</p>
              </div>
              <div className="main-subpage-content">
                <div id="user-box-left">
                  <div className="user-fullname">{data.userName}</div>
                  <div className="user-photo">
                    <img
                      src={data.image ? `/rest/sparingpartner/image/${data.image}` : `/images/sparinguploads/default_sparing.png`}
                      style={{ maxHeight: 300, maxWidth: 365 }}
                      alt="Zdjęcie sparingpartnera"
                      onError={(e) => {
                        if (e.target.src.indexOf("/images/sparinguploads/default_sparing.png") === -1) {
                          e.target.src = "/images/sparinguploads/default_sparing.png";
                        }
                      }}
                    />

                    <div className="user-status">{data.gameLevelName}</div>
                  </div>

                  <div className="user-icon-location user-icon semibold">
                    {data.userCity} ({data.userProvince})
                  </div>
                  <div className="user-icon-contact user-icon semibold">
                    {data.userPhone}
                  </div>
                  <div className="user-icon-mail user-icon semibold">
                    {data.userEmail}
                  </div>
                  <div style={{ clear: "both" }}></div>
                </div>
                <div id="user-box-right">
                  <div className="user-box-right-nag">Treść ogłoszenia:</div>
                  <div className="user-box-right-desc" style={descStyle}>
                    {he.decode(data.description)}
                  </div>
                  <div className="user-box-right-nag">Miejsce gry:</div>
                  <div className="user-box-right-desc">
                    1. <a href={"/klub/" + data.clubWww1}>{data.clubName1}</a>
                    {data.clubName2 !== null && data.clubName2 !== "" && (
                      <>
                        <br />
                        2. <a href={"/klub/" + data.clubWww2}>{data.clubName2}</a>
                      </>
                    )}
                    {data.clubName3 !== null && data.clubName3 !== "" && (
                        <>
                          <br />
                          3. <a href={"/klub/" + data.clubWww3}>{data.clubName3}</a>
                        </>
                      )}
                  </div>
                  <div className="user-box-right-nag">
                    Preferowane terminy gry:
                  </div>
                  <div className="user-box-right-desc" style={descStyle}>{he.decode(data.preferredDates)}</div>
                </div>
                <div style={{ clear: "both" }}></div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}

export default SparingpartnerPage;